<agr-form [formGroup]="formGroup">
  <div class="flex--row flex--nowrap cropfield-row">
    <div class="flex--column flex--nowrap">
      <div class="flex--row flex--nowrap text--label edit-row">
        <mat-form-field class="flex__child--auto edit-row__field edit-row__name">
          <mat-label>{{ 'fieldName' | translate }}</mat-label>
          <input
            matInput
            [placeholder]="'fieldName' | translate"
            formControlName="name"
            data-test="quickedit-cropfield-name"
            (keydown)="$event.stopPropagation()"
          />
        </mat-form-field>

        <mat-form-field
          class="flex__child--auto spacing--padding-half-left edit-row__field edit-row__ha"
        >
          <mat-label>{{ 'hectare-abbreviated' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            [min]="0.1"
            [step]="0.01"
            [placeholder]="'hectare' | translate"
            formControlName="areaInHectares"
            data-test="quickedit-cropfield-hectares"
          />
        </mat-form-field>

        <mat-form-field
          class="flex__child--auto spacing--padding-half-left edit-row__field edit-row__crop"
        >
          <mat-label>{{ 'crop' | translate }} </mat-label>
          <input
            type="text"
            [placeholder]="'crop' | translate"
            matInput
            formControlName="cropId"
            [matAutocomplete]="cropAutocomplete"
            data-test="quickedit-cropfield-crop"
            appClearOnFocus
          />
          <mat-autocomplete #cropAutocomplete="matAutocomplete" [displayWith]="displayCrop()">
            @for (crop of filteredCrops$ | async; track crop) {
              <mat-option [value]="crop.id" data-test="quickedit-cropfield-crop-option">
                {{ crop.name }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field
          class="flex__child--auto spacing--padding-half-left edit-row__field edit-row__crop-variety"
        >
          <mat-label>{{ 'cropVariety' | translate }} </mat-label>
          <input
            type="text"
            [placeholder]="'cropVariety' | translate"
            matInput
            formControlName="cropVarietyId"
            [matAutocomplete]="cropVarietyAutocomplete"
            data-test="quickedit-cropfield-crop-variety"
          />
          @if (isLoadingBemCropVarieties()) {
            <mat-spinner
              matSuffix
              [diameter]="20"
              [attr.aria-label]="'loadingCropVarieties' | translate"
              data-test="quickedit-cropfield-crop-variety-loading"
            ></mat-spinner>
          }
          <mat-autocomplete
            #cropVarietyAutocomplete="matAutocomplete"
            [displayWith]="displayCropVariety()"
          >
            @for (option of filteredCropVarieties$ | async; track option) {
              <mat-option [value]="option.id" data-test="quickedit-cropfield-crop-variety-option">
                {{ option.name }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field
          class="flex__child--auto spacing--padding-half-left edit-row__field edit-row__crop"
        >
          <mat-label>{{ 'buyer' | translate }}</mat-label>
          <mat-select formControlName="chainPartnerId" data-test="quickedit-cropfield-chainPartner">
            <mat-option [value]="null">{{ 'none' | translate }}</mat-option>
            @for (chainPartner of buyerChainPartners$ | async; track chainPartner.id) {
              <mat-option [value]="chainPartner.id">{{ chainPartner.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field
          class="flex__child--auto spacing--padding-half-left edit-row__field edit-row__crop"
        >
          <mat-label>{{ 'concept' | translate }}</mat-label>
          <mat-select formControlName="conceptId" data-test="quickedit-cropfield-concept">
            <mat-option [value]="null">{{ 'none' | translate }}</mat-option>
            @for (concept of concepts$ | async; track concept.id) {
              <mat-option [value]="concept.id">{{ concept.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field
          class="flex__child--auto spacing--padding-half-left edit-row__field edit-row__soiltype"
        >
          <mat-label>
            {{ 'soilType' | translate }}
            @if (isPrefilling$ | async) {
              <mat-spinner class="prefill-spinner" [diameter]="16"></mat-spinner>
            }
          </mat-label>
          <mat-select formControlName="soilTypeId" data-test="quickedit-cropfield-soilType">
            @for (soilType of data.soilTypes; track soilType) {
              <mat-option [value]="soilType.id">
                {{ soilType.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field
          class="flex__child--auto spacing--padding-half-left edit-row__field edit-row__province"
        >
          <mat-label>
            {{ 'province' | translate }}
          </mat-label>
          <mat-select formControlName="province" data-test="quickedit-cropfield-province">
            @for (province of eProvince | keyvalue; track province) {
              <mat-option [value]="province.key">
                {{ province.value }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field
          class="flex__child--auto spacing--padding-half-left edit-row__field edit-row__depth"
        >
          <mat-label>{{ 'machiningDepth' | translate }} (cm)</mat-label>
          <input
            matInput
            agrNumber
            maxlength="2"
            [placeholder]="'machiningDepth' | translate"
            formControlName="machiningDepthInCentimeters"
            [min]="0"
            [step]="1"
            data-test="quickedit-cropfield-machiningDepthInCentimeters"
          />
        </mat-form-field>

        <mat-form-field
          class="flex__child--auto spacing--padding-half-left edit-row__field edit-row__start-date"
          data-test="quickedit-cropfield-startDate"
        >
          <mat-label>{{ 'startDate' | translate }}</mat-label>
          <input
            matInput
            formControlName="startDate"
            [matDatepicker]="startDatePicker"
            [placeholder]="'startDate' | translate"
          />
          <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field
          class="flex__child--auto spacing--padding-half-left edit-row__field edit-row__end-date"
          data-test="quickedit-cropfield-endDate"
        >
          <mat-label>{{ 'endDate' | translate }}</mat-label>
          <input
            matInput
            formControlName="endDate"
            [matDatepicker]="endDatePicker"
            [placeholder]="'endDate' | translate"
          />
          <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="flex--row flex--nowrap text--label options-row spacing--margin-bottom">
        <mat-label class="flex__child--0 spacing--padding-half-left text--label edit-row__options"
          >Opties</mat-label
        >

        <mat-slide-toggle
          color="primary"
          formControlName="isAreaCalculated"
          data-test="quickedit-cropfield-isAreaCalculated"
          class="flex--justify-left spacing--padding-left text--label"
        >
          {{ 'hectareCalculated' | translate }}
        </mat-slide-toggle>

        <mat-slide-toggle
          color="primary"
          formControlName="isSkal"
          data-test="quickedit-cropfield-isSkal"
          class="flex--justify-left spacing--padding-left text--label"
        >
          {{ 'organic' | translate }}
        </mat-slide-toggle>

        <mat-slide-toggle
          color="primary"
          formControlName="isPlanetProof"
          data-test="quickedit-cropfield-isPlanetProof"
          class="flex--justify-left spacing--padding-left text--label"
        >
          {{ 'planetProof' | translate }}
        </mat-slide-toggle>

        <mat-slide-toggle
          color="primary"
          formControlName="isGroundWaterPreservation"
          data-test="quickedit-cropfield-isGroundWaterPreservation"
          class="flex--justify-left spacing--padding-left text--label"
        >
          {{ 'isGroundWaterPreservation' | translate }}
          @if (isPrefilling$ | async) {
            <mat-spinner class="prefill-spinner" [diameter]="16"></mat-spinner>
          }
        </mat-slide-toggle>

        <mat-slide-toggle
          color="primary"
          formControlName="isGroundWaterPreservationWithNitrogenCuts"
          data-test="quickedit-cropfield-isGroundWaterPreservationWithNitrogenCuts"
          class="flex--justify-left spacing--padding-left text--label"
        >
          {{ 'isGroundWaterPreservationWithNitrogenCuts' | translate }}
          @if (isPrefilling$ | async) {
            <mat-spinner class="prefill-spinner" [diameter]="16"></mat-spinner>
          }
        </mat-slide-toggle>

        <mat-slide-toggle
          color="primary"
          formControlName="isNutrientsPollutedArea"
          data-test="quickedit-cropfield-isNutrientsPollutedArea"
          class="flex--justify-left spacing--padding-left text--label"
        >
          {{ 'isNutrientsPollutedArea' | translate }}
          @if (isPrefilling$ | async) {
            <mat-spinner class="prefill-spinner" [diameter]="16"></mat-spinner>
          }
        </mat-slide-toggle>

        <mat-slide-toggle
          color="primary"
          formControlName="isSandySoil"
          data-test="quickedit-cropfield-isSandySoil"
          class="flex--justify-left spacing--padding-left text--label"
        >
          {{ 'sandySoil' | translate }}
          @if (isPrefilling$ | async) {
            <mat-spinner class="prefill-spinner" [diameter]="16"></mat-spinner>
          }
        </mat-slide-toggle>

        <mat-slide-toggle
          color="primary"
          formControlName="isRentedField"
          data-test="quickedit-cropfield-isRentedField"
          class="flex--justify-left spacing--padding-left text--label"
        >
          {{ 'rentedField' | translate }}
          @if (isPrefilling$ | async) {
            <mat-spinner class="prefill-spinner" [diameter]="16"></mat-spinner>
          }
        </mat-slide-toggle>

        <mat-slide-toggle
          color="primary"
          formControlName="outsideDutchBorders"
          data-test="quickedit-cropfield-outsideDutchBorders"
          class="flex--justify-left spacing--padding-left text--label"
        >
          {{ 'abroad' | translate }}
          @if (isPrefilling$ | async) {
            <mat-spinner class="prefill-spinner" [diameter]="16"></mat-spinner>
          }
        </mat-slide-toggle>
      </div>
    </div>

    <mat-form-field
      class="flex__child--auto spacing--padding-half-left text--label edit-row__field edit-row__soil-analysis"
    >
      <mat-label>{{ 'soilAnalyses' | translate }}</mat-label>
      <mat-chip-grid #chipList>
        @for (soilAnalysis of selectedSoilAnalyses$ | async; track soilAnalysis; let i = $index) {
          <mat-chip-row [removable]="true" (removed)="removeSoilAnalysis(i)" class="text--label">
            {{ soilAnalysis?.description }} {{ getSoilAnalysisYear(soilAnalysis) }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip-row>
        }
        <input
          #soilAnalysesInput
          [placeholder]="'soilAnalyses' | translate"
          [formControl]="soilAnalysesControl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="true"
          (matChipInputTokenEnd)="addSoilAnalysis($event)"
        />
      </mat-chip-grid>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectSoilAnalysis($event)">
        <mat-optgroup [label]="'ownSoilAnalyses' | translate">
          <mat-option [value]="false">{{ 'addManualSoilAnalysis' | translate }}</mat-option>
          @for (soilAnalysis of filteredSoilAnalyses$ | async; track soilAnalysis) {
            <mat-option [value]="soilAnalysis.id">
              {{ soilAnalysis?.description }} {{ getSoilAnalysisYear(soilAnalysis) }}
            </mat-option>
          }
        </mat-optgroup>
        <mat-optgroup [label]="'defaultSoilAnalyses' | translate">
          @for (soilAnalysis of filteredDefaultSoilAnalyses$ | async; track soilAnalysis) {
            <mat-option [value]="soilAnalysis.id">
              {{ soilAnalysis?.description }}
            </mat-option>
          }
        </mat-optgroup>
      </mat-autocomplete>
    </mat-form-field>
  </div>
</agr-form>
